"use client";

import React from "react";
import { ShellLink } from "@/src/components";
import { Icon } from "@ospweb/sdk-ui";
import Translations from "@translate/components/ViewAllButton";
import { I18nUtil } from "@utils";

const I18n = I18nUtil.createScoped(Translations);

interface ViewAllButtonProps {
  href: string;
  className?: string;
  text?: string;
}

/**
 * ViewAllButton component for navigation to view all items
 */
export const ViewAllButton: React.FC<ViewAllButtonProps> = ({
  href,
  className = "",
  text,
}) => {
  return (
    <ShellLink
      aria-label="View All Button"
      data-openreplay-label={`View All Button Link | ${href}`}
      id="lnk-view-all-button"
      href={href}
    >
      <div
        className={`flex items-center flew-row ${className} text-content_tertiary hover:text-content_secondary duration-200`}
      >
        <span className="button_s  whitespace-nowrap w-fit">
          {text || I18n.t("View all")}
        </span>
        <Icon
          name="right-arrow-alt"
          size={16}
          // className="text-content_tertiary"
        />
      </div>
    </ShellLink>
  );
};
